import type { DebugInfos } from "../ProtocolEntry";
import { AtomErrors } from "./AtomErrors";
import type { InternalErrors } from "./InternalErrors";

export type ErrorDebugInfos = DebugInfos & {
  errorCode?: string;
};

export interface ErrorWithDebugInfosLike {
  type: string;
  message: string;
  debugInfos: ErrorDebugInfos;
}

export class ErrorWithDebugInfos extends Error {
  constructor(
    public type: string,
    public message: string,
    public debugInfos: ErrorDebugInfos = {},
  ) {
    super(message);
  }
}

export class FrameworkInternalError extends ErrorWithDebugInfos {
  constructor(
    errorCode: InternalErrors | string,
    debugInfos: ErrorDebugInfos = {},
  ) {
    const message =
      typeof debugInfos.message === "string"
        ? debugInfos.message
        : `internal error: ${errorCode}`;

    super(AtomErrors.InternalError, message, {
      ...debugInfos,
      errorCode,
    });
  }
}
